
















// Vue
import Vue, { PropType } from "vue";
// Constants
import { DaysOfWeek } from "@/core/api/apiClient";

export default Vue.extend({
  name: "DaysSelector",

  props: {
    value: {
      type: Array as PropType<DaysOfWeek[]>,
      default: () => []
    }
  },

  data() {
    return {
      days: Object.values(DaysOfWeek),
      dayOfWeekDisplay: {
        [DaysOfWeek.Sunday]: "Sunday",
        [DaysOfWeek.Monday]: "Monday",
        [DaysOfWeek.Tuesday]: "Tuesday",
        [DaysOfWeek.Wednesday]: "Wednesday",
        [DaysOfWeek.Thursday]: "Thursday",
        [DaysOfWeek.Friday]: "Friday",
        [DaysOfWeek.Saturday]: "Saturday",
      },

      localValue: this.value ?? []
    };
  },

  watch: {
    value: function (newValue) {
      this.localValue = newValue;
    }
  },

  methods: {
    handleValueChange() {
      this.$emit("input", this.localValue);
    }
  }
});
